<template>
    <div class="favourite" :class="{'active' : isFavourite}" @click.prevent="toggleFavourite">
        <Icon name="heart-outline" class="outline"></Icon>
        <Icon name="heart" class="filled"></Icon>
    </div>
</template>

<script>
import * as api from '../api'
import { mapGetters } from "vuex"


export default {
    props: {
        workoutId: {
            type: String,
            default: ''
        },
        favourited: {
            type: Boolean,
            default: undefined
        }
    },
    data () {
        return {
            isFavourite: this.favourited,
        }
    },
    mounted() {
        if(this.isFavourite === undefined) {
            this.checkIfFavourite()
        }
    },
    computed: {
        ...mapGetters(['userFavourites']),
    },
    methods: {
        toggleFavourite() {
            this.isFavourite = !this.isFavourite
            this.updateFavourite(this.isFavourite)
        },
        async updateFavourite(isFavourite) {
            try {
                if(!isFavourite) {
                    await api.workout.unfavourite({id: this.workoutId})
                } else {
                    await api.workout.favourite({id: this.workoutId})
                }
            } catch(error) {
                console.error(error)
            }
        },
        checkIfFavourite() {
            const matchingWorkout = this.userFavourites.find(workout => {
                return workout.id === this.workoutId
            })
            if(matchingWorkout !== undefined) {
                this.isFavourite = true
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.favourite {
    position: relative;
    cursor: pointer;

    &.active {
        .filled {
            opacity: 1;
        }
    }

    .icon {
        transition: opacity 200ms $ease-out-quad;
    }

    .filled {
        @include fillout;
        opacity: 0;
    }
}
</style>